export default {
    stateCopy: {
        copyLocations: {
            "Window.platformId" : "Window.Skin",
            "Window.GlobalLaunchPointName" : "WelcomeUser.LaunchPointName",
        },
    },
};


// WEBPACK FOOTER //
// ./settings/state-copy.ts